import { InvoiceStatus } from '../swagger/api';

export enum MKInvoiceStatus {
  Paid = 'Paid',
  NotPaid = 'NotPaid',
  MissingPayment = 'MissingPayment',
  Credit = 'Credit',
  AllOpen = 'AllOpen'
}

export const GetPaidInvoiceStatuses = (): Array<InvoiceStatus> => [
  InvoiceStatus.Paid,
  InvoiceStatus.CreditNote,
  InvoiceStatus.ManualRemittance,
  InvoiceStatus.PaidOut,
  InvoiceStatus.PaidByBalance
];

export const GetNotPaidInvoiceStatuses = (): Array<InvoiceStatus> => [
  InvoiceStatus.Pending,
  InvoiceStatus.AutomatedRemittance,
  InvoiceStatus.PaymentFailed,
  InvoiceStatus.SentToExternalDebtCollection,
  InvoiceStatus.PendingExternalDebtCollection,
  InvoiceStatus.PaymentReminderSent
];

export const GetCreditInvoiceStatuses = (): Array<InvoiceStatus> => [
  InvoiceStatus.ManualRemittance,
  InvoiceStatus.PendingExternalDebtCollection,
  InvoiceStatus.SentToExternalDebtCollection
];

export const GetAllOpenInvoiceStatuses = (): Array<InvoiceStatus> => [
  InvoiceStatus.Pending,
  InvoiceStatus.PaymentReminderSent,
  InvoiceStatus.PendingExternalDebtCollection,
  InvoiceStatus.SentToExternalDebtCollection,
  InvoiceStatus.ManualRemittance,
  InvoiceStatus.AutomatedRemittance,
  InvoiceStatus.PaymentFailed
];

export const GetInvoiceStatusesByMKInvoiceStatus = (
  status: MKInvoiceStatus
): Array<InvoiceStatus> => {
  switch (status) {
    case MKInvoiceStatus.Paid:
      return GetPaidInvoiceStatuses();
    case MKInvoiceStatus.MissingPayment:
    case MKInvoiceStatus.NotPaid:
      return GetNotPaidInvoiceStatuses();
    case MKInvoiceStatus.Credit:
      return GetCreditInvoiceStatuses();
    case MKInvoiceStatus.AllOpen:
      return GetAllOpenInvoiceStatuses();
    default:
      return GetNotPaidInvoiceStatuses();
  }
};

export const IsInvoicePaid = (invoiceStatus?: InvoiceStatus | null): boolean =>
  invoiceStatus != null && GetPaidInvoiceStatuses().includes(invoiceStatus);

export const IsInvoiceNotPaid = (invoiceStatus?: InvoiceStatus | null): boolean =>
  invoiceStatus == null || GetNotPaidInvoiceStatuses().includes(invoiceStatus);

export const MapToMKInvoiceStatus = (status: InvoiceStatus): MKInvoiceStatus => {
  if (GetPaidInvoiceStatuses().includes(status)) {
    return MKInvoiceStatus.Paid;
  }
  return MKInvoiceStatus.NotPaid;
};
